import clsx from 'clsx';
import { DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';

export const DragHandle = forwardRef(
  ({ className, ...rest }: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => (
    <div className={clsx('drag-handle', className)} {...rest} />
  )
);
